import { Link } from 'react-router-dom';
import { ArrowLeft, Sparkle, Rocket, Wrench } from '@phosphor-icons/react';

const RELEASES = [
  {
    version: '1.0',
    date: 'Feb 19, 2026',
    tag: 'Launch',
    icon: Rocket,
    color: '#FF3B30',
    highlights: [
      'Launched GRIT.FIT — AI-powered home workouts with zero equipment',
      '21 bodyweight exercises across 7 body parts with video demos',
      'AI-generated workout plans personalized to your level and goals',
      'Mobile-first Workout Player with Screen Wake Lock, voice coach ("3, 2, 1, Go!"), swipe gestures, and landscape mode',
      'Streak system + community challenges + accountability buddy pairing',
      'Public + Friends leaderboards with opt-in privacy',
      'Analytics dashboard with 12-week volume chart, 90-day heatmap, personal records',
      'Push notifications with timezone-aware scheduling, Smart Mode (learns your median workout hour), and Streak-Save alerts',
      'Stripe-powered Pro tier with live payments',
      'PWA with offline support — installable on Android, iOS, and desktop',
      'CSV/JSON export for Apple Health / Google Fit compatibility',
      'Full GDPR compliance: data export, account deletion, privacy controls',
    ],
  },
];

export default function ChangelogPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-4 sm:px-6 py-10" data-testid="changelog-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors mb-8 text-sm" data-testid="changelog-back-link">
          <ArrowLeft weight="bold" className="w-4 h-4" /> Back to GRIT.FIT
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#FF3B30]/10 border border-[#FF3B30]/30 flex items-center justify-center">
            <Sparkle weight="fill" className="w-6 h-6 text-[#FF3B30]" />
          </div>
          <div>
            <div className="label-tactical text-[#FF3B30]">Updates</div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter">WHAT'S NEW</h1>
          </div>
        </div>
        <p className="text-[#A1A1AA] text-sm sm:text-base mb-10 leading-relaxed">
          We ship updates often. Here's everything that's changed.
        </p>

        <div className="space-y-10">
          {RELEASES.map((r) => {
            const Icon = r.icon;
            return (
              <div key={r.version} className="relative pl-8 border-l-2 border-white/10" data-testid={`release-${r.version}`}>
                <div
                  className="absolute -left-[11px] top-1 w-5 h-5 flex items-center justify-center"
                  style={{ backgroundColor: r.color }}
                >
                  <Icon weight="fill" className="w-3 h-3 text-white" />
                </div>
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <h2 className="text-3xl font-black tracking-tighter">v{r.version}</h2>
                  <span
                    className="inline-block px-2.5 py-0.5 text-[10px] font-black uppercase tracking-widest"
                    style={{
                      color: r.color,
                      backgroundColor: `${r.color}15`,
                      border: `1px solid ${r.color}44`,
                    }}
                  >
                    {r.tag}
                  </span>
                  <span className="text-xs text-[#71717A]">{r.date}</span>
                </div>
                <ul className="space-y-2 text-sm text-[#D4D4D8]">
                  {r.highlights.map((h, i) => (
                    <li key={i} className="flex gap-2 leading-relaxed">
                      <span className="text-[#FF3B30] flex-shrink-0 mt-1.5">•</span>
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <Wrench weight="fill" className="w-6 h-6 text-[#71717A] mx-auto mb-3" />
          <p className="text-sm text-[#A1A1AA]">Have a feature idea?</p>
          <Link to="/contact" className="inline-block mt-2 text-[#FF3B30] font-bold text-sm hover:underline" data-testid="changelog-contact-link">
            Send us a message →
          </Link>
        </div>
      </div>
    </div>
  );
}
